import { ThemeDirective } from './../directives/theme.directive';
import { ThemingService } from './theming.service';
import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { THEMES, ACTIVE_THEME, ThemeOptions } from '../models/system/theme';

@NgModule({
  imports: [CommonModule],
  providers: [ThemingService],
  declarations: [ThemeDirective],
  exports: [ThemeDirective]
})
export class ThemingModule {
  static forRoot(options: ThemeOptions): ModuleWithProviders {
    return {
      ngModule: ThemingModule,
      providers: [
        {
          provide: THEMES,
          useValue: options.themes
        },
        {
          provide: ACTIVE_THEME,
          useValue: options.active
        }
      ]
    };
  }
}
